<template>
    <div id="app-buying">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div class="text-header">Общая информация</div>
                <div class="white-card">
                    <div class="white-card__data-row">Номер закупки: <span class="pull-right">{{ id }}</span></div>
                    <div class="white-card__data-row">Размещено: <span
                            class="pull-right">{{ dateCreate }}</span></div>
                    <div class="white-card__data-row">Тип закупки: <span
                            class="pull-right">{{ typeName }}</span></div>
                    <div class="white-card__data-row">Общая категория:
                        <span class="pull-right" v-for="good in unique(goods, 'prototypeGroup')">{{ good.prototypeGroup }}</span><br>
                    </div>
                    <div class="white-card__data-row">Подкатегория:
                        <span class="pull-right" v-for="good in unique(goods, 'prototypeSubGroup')">{{ good.prototypeSubGroup }}</span><br>
                    </div>
                    <div class="white-card__data-row">Этап закупки: <span
                            class="pull-right">{{ statusName }}</span></div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="white-card dopInfoCard">
                    <div class="white-card__data-row -style-big">Всего товаров: <span
                            class="pull-right">{{ itemsCount }} ед.</span></div>
                    <div class="white-card__data-row -style-big">Общая цена: <span
                            class="pull-right">{{ sum | pricePrecision  }} <i class="fa fa-ruble"></i></span></div>
                    <div class="white-card__data-row -style-big">Дата и время подведения итогов: <span
                            class="pull-right">{{ dateOffer }}</span></div>
                </div>
                <div class="export-tools -style-buying no-print" v-if="false">
                    <a href="javascript:window.print()" class="btn -style-dark scr-print"><i class="fa fa-print"></i> Печать</a>
                    <a :href="getExportLink('excel')" class="btn -style-dark"><i class="fa fa-file-excel-o"></i> Экспорт
                        Excel</a>
                    <a :href="getExportLink('email')" class="btn -style-dark"><i class="fa fa-envelope-o"></i> Отправить
                        email</a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="text-header">Информация об объекте закупки</div>
                <div class="white-card">
                    <table class="table buying__items-table-table">
                        <thead>
                        <tr>
                            <th>Изображение</th>
                            <th class="col-sm-6 col-md-4">Наименование</th>
                            <th>Кол-во</th>
                            <th>Ед.изм.</th>
                            <th>НМЦК</th>
                            <th>Предложение за ед., <i class="fa fa-ruble"></i></th>
                            <th>Падение <i class="fa fa-percent"></i></th>
                            <th>Цена, <i class="fa fa-ruble"></i></th>
                            <th v-if="isCollective"></th>
                        </tr>
                        </thead>
                        <tbody role="rowgroup">
                        <tr v-for="item in goods" :key="item.itemId" v-if="seeType == 'all' || item.prototypeIsParticipate">
                            <td>
                                <img class="item-teaser__image" :src='item.prototypeImage' alt="" @error="$event.target.src='/images/no-photo.jpg'">
                            </td>
                            <td class="mobile-font">
                                <a :href="'/catalog/default/prototype-view?cat=' + item.prototypeCategoryId" target="_blank">{{ item.prototypePossibleValue }}</a>
                            </td>
                            <td class="mobile-font">
                                <span v-show="!isEditMode" v-if="seeType == 'all'">{{ item.prototypeCount }}</span>
                                <span v-show="!isEditMode" v-else>{{ item.prototypeCountForUser }}</span>
                                <div class="number-input" v-show="isEditMode">
                                    <div class="number-input__minus" v-on:click="decreaseCount(item)">-</div>
                                    <input type="number" step="1" min="1" class="number-input__field"
                                           v-on:input="change(item)" v-model="item.prototypeCountForUser">
                                    <div class="number-input__plus" v-on:click="increaseCount(item)">+</div>
                                </div>
                            </td>
                            <td class="mobile-font">{{ item.prototypeUnit }}</td>
                            <td class="mobile-font">{{ item.prototypeContractStartPrice | pricePrecision }}</td>
                            <td class="mobile-font">{{ item.minOffer | pricePrecision }}</td>
                            <td class="mobile-font">{{ item.percentageReduction | pricePrecision }}</td>
                            <td class="mobile-font" v-if="seeType == 'all'">{{ item.minOffer * item.prototypeCount | pricePrecision }}</td>
                            <td class="mobile-font" v-else>{{ item.minOffer * item.prototypeCountForUser | pricePrecision }}</td>
                            <!--                            <td>{{ item.minOffer * item.prototypeCountForUser | pricePrecision }}</td>-->
                            <td v-if="isObserver" class="no-print">
                                <collective-join
                                        :buying-id="id"
                                        :buying-type="type"
                                        :buying-item="item"
                                        :is-demo-user="isDemoUser"
                                        @join-success="getBuying">
                                </collective-join>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row" v-if="isTenderOrDraft && !isObserver">
            <div class="col-sm-12">
                <div class="col-sm-12 col-md-8 col-md-offset-2 buying-list__btns no-print">
                    <a id="publish-buying" :href="'/buyer/buying/publish?id=' + id"
                       class="btn -color-green -size-big" v-if="isIndividual && isDraft">Опубликовать</a>
                    <a id="editBuying" class="btn -color-green -size-big" v-on:click="changeMode()"
                       v-if="!isDraft">{{ isEditMode ?
                        'Сохранить' : 'Редактировать' }}</a>
                    <a id="removeBuying" :href="'/buyer/buying/remove?id=' + id"
                       class="btn -style-warning -size-big" v-if="isIndividual">Удалить</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Buyings from "../services/BuyingService";
    import CollectiveJoin from "./CollectiveJoin";

    const COMPONENT_NAME = 'buying';

    export default {
        name: COMPONENT_NAME,
        components: {CollectiveJoin},
        props: ['id', 'type', 'userId', 'city', 'seeType'],
        data() {
            return {
                buying: null,
                dateCreate: '',
                dateOffer: '',
                typeName: '',
                statusName: '',
                itemsCount: 0,
                sum: 0,
                goods: [],
                isTenderOrDraft: false,
                isObserver: true,
                isIndividual: false,
                isCollective: false,
                isDraft: false,
                isProcessing: false,
                isDemoUser: false,
                minimalOffers: [],
                isEditMode: null,
                dataObject: []
            }
        },
        mounted() {
            this.getBuying();
        },
        methods: {
            async getBuying() {
                try {
                    let response = await Buyings.getBuying(this.id, this.type);
                    if (response.success) {
                        this.dataObject = response;
                        this.buying = response.buying;
                        this.dateCreate = response.dateCreate;
                        this.typeName = response.typeName;
                        this.statusName = response.statusName;
                        this.itemsCount = response.itemsCount;
                        this.sum = response.sum;
                        this.dateOffer = response.offerDate;
                        this.goods = response.goods;
                        this.isTenderOrDraft = response.isTenderOrDraft;
                        this.isObserver = response.isObserver;
                        this.isIndividual = response.isIndividual;
                        this.isCollective = !response.isIndividual;
                        this.isDraft = response.isDraft;
                        this.isProcessing = response.isProcessing;
                        this.isDemoUser = response.isDemoUser;
                        this.minimalOffers = response.minimalOffers;
                    } else {
                        window.location.href = '/buyer/default';
                    }
                } catch (e) {
                    console.error(e);
                }
            },
            getExportLink(exportType) {
                return `/buyer/buying/index?id=${this.id}&type=${this.type}&${exportType}=on`;
            },
            async changeMode() {
                if (this.isEditMode) {
                    let response = await Buyings.updateCount(this.dataObject);
                    if (response) {
                        this.$notify({message: response.result, type: 'success'});
                        this.getBuying();
                    }
                }
                this.isEditMode = !this.isEditMode;
            },
            decreaseCount: function (item) {
                // if (this.isIndividual) {
                if (item.prototypeCountForUser - 1 > 0) {
                    item.prototypeCountForUser--;
                }
                // } else {
                //         let this_vue = this;
                //         this_vue.$notify({message: 'Новое количество товаров должно быть больше начального', type: 'fail'});
                //     }
            },
            increaseCount: function (item) {
                item.prototypeCountForUser++;
            },
            change: function (item) {
                if (item.prototypeCountForUser < 1) {
                    item.prototypeCountForUser = 1;
                }
            }
        },
        filters: {
            pricePrecision: function (value) {
                if (!value) value = '';
                value = new Number(value);
                value = value.toFixed(2);

                return value;
            }
        }
    }
</script>

<style scoped>

    .dopInfoCard {
        margin-top: 63px;
    }

    @media
    only screen
    and (max-width: 768px), (min-device-width: 768px)
    and (max-device-width: 1024px)  {

        .scr-print {
            display: none;
        }

        td.mobile-font {
            font-size: 18px !important;
            font-weight: bold;
        }

        table, thead, tbody, th, td, tr {
            display: block;
        }

        thead tr {
            display: none;
            position: absolute;
            top: -9999px;
            left: -9999px;
        }

        tr {
            margin: 0 0 2rem 0;
        }

        td {
            border: none;
            /*border-bottom: 1px solid #eee;*/
            position: relative;
            padding-left: 50%;
            align-content: start;
        }

        td:before {
            position: relative;
            left: 6px;
            width: 45%;
            padding-right: 10px;
            white-space: nowrap;
        }

        td:nth-of-type(1):before { font-size: 14px; font-weight: normal; content: 'Наименование: '; }
        td:nth-of-type(2):before { font-size: 14px; font-weight: normal; content: 'Кол-во: '; }
        td:nth-of-type(3):before { font-size: 14px; font-weight: normal; content: 'Ед.изм.: '; }
        td:nth-of-type(4):before { font-size: 14px; font-weight: normal; content: 'НМЦК: '; }
        td:nth-of-type(5):before { font-size: 14px; font-weight: normal; content: 'Предложение за ед.: '; }
        td:nth-of-type(6):before { font-size: 14px; font-weight: normal; content: 'Падение: '; }
        td:nth-of-type(7):before { font-size: 14px; font-weight: normal; content: 'Цена: '; }
    }

</style>